import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> { }

const TrashIcon: React.FC<Props> = (props) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M12.9528 17.5035H7.04797C6.06781 17.5035 5.25289 16.7489 5.17772 15.7716L4.37305 5.31091H15.6277L14.8231 15.7716C14.7479 16.7489 13.933 17.5035 12.9528 17.5035V17.5035Z" stroke={props.stroke || "#008AF6"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16.669 5.31113H3.33008" stroke={props.stroke || "#008AF6"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path fillRule="evenodd" clipRule="evenodd" d="M7.65469 2.49683H12.3441C12.8621 2.49683 13.282 2.91673 13.282 3.43472V5.3105H6.7168V3.43472C6.7168 2.91673 7.1367 2.49683 7.65469 2.49683Z" stroke={props.stroke || "#008AF6"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.6414 9.0625V13.752" stroke={props.stroke || "#008AF6"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.35825 9.0625V13.752" stroke={props.stroke || "#008AF6"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default TrashIcon;
